export const AUTH_SUCCESS="AUTH_SUCCESS"
export const AUTH_FAILED="AUTH_FAILED"
export const AUTH_LOADING="AUTH_LOADING"
export const AUTH_LOGOUT="AUTH_LOGOUT"
export const LOAD_PROBLEMS="LOAD_PROBLEMS"
export const LOAD_PROBLEMS_FAILED="LOAD_PROBLEMS_FAILED"
export const CURRENT_PROBLEM="CURRENT_PROBLEM"